import React, { useState } from 'react'
import HeaderTabLayout from '../../components/HeaderTabLayout'
import Layout from '../../components/Layout'
import CustomAddForm from '../../components/version-4/MasterForms/CustomAddForm'
import { useLeaveType } from '../../hooks/CompanyConfiguration/useLeaveType'
import { ROUTES } from '../../shared/constants'

function LeaveTypeForm({ leaveType }) {
  const [LeaveData, setLeaveData] = useState({
    name: '',
  })
  const { addLeaveType, updateLeaveType, loading } = useLeaveType()

  const handleLeaveType = () => {
    if (leaveType) {
      updateLeaveType({ name: LeaveData.name, leaveTypeId: leaveType._id })
    } else {
      addLeaveType({ name: LeaveData.name })
    }
  }
  React.useEffect(() => {
    if (leaveType) {
      setLeaveData({
        name: leaveType.name,
      })
    }
  }, [leaveType])
  const formData = [{ label: 'Name', value: LeaveData.name, name: 'name' }]
  return (
    <Layout heading="Leave Type" heading2={leaveType ? 'Edit' : 'Add'} url1={ROUTES.LEAVE_TYPE} form none>
      <HeaderTabLayout
        heading="Leave Type"
        content={<CustomAddForm state={LeaveData} setState={setLeaveData} data={formData} />}
        addContent={handleLeaveType}
        redirect={ROUTES.LEAVE_TYPE}
        loading={loading}
        state={LeaveData} setState={setLeaveData}
      />
    </Layout>
  )
}

export default LeaveTypeForm
